import React, { useEffect, useRef, useState } from "react";
import Gallery from "../Components/Gallery";
import Footer from "../Components/Footer/Footer";
import ReactPlayer from "react-player";
import FooterMob from "../Components/Footer/FooterMob";
import { Link, useNavigate } from "react-router-dom";
import NewGallery from "../Components/NewGallery";
import "./NewGallery.css";
import Footer2 from "../Components/Footer/Footer2";
import TabletFooter from "../Components/Footer/TabletFooter";

function GalleryScreen() {
  const [openGalery, setOpenGalery] = useState(false);
  const [imageWidth, setImageWidth] = useState(window.innerWidth / 3);

  const footerRef = useRef(null);

  const scrollToFooter = () => {
    footerRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const actingRef = useRef(null);

  const scrollToActing = () => {
    // actingRef.current.scrollIntoView({ behavior: "smooth" });
    const scrollToActing = () => {
      // Navigate to home route with a state indicating the scroll target
      window.location.href = "/home#acting";
    };
  };

  const [isShown, setIsShown] = useState(false);

  // Function to toggle the "show" class
  const toggleShow = () => {
    setIsShown((prevState) => !prevState);
  };

  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlaying2, setIsPlaying2] = useState(false);

  const [isMobile, setIsMobile] = useState(true);
  const [isTablet, setIsTablet] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };

    // Initial check on mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handlePlayPause2 = () => {
    setIsPlaying2(!isPlaying2);
  };

  const clickGalery = () => {
    setOpenGalery(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setImageWidth(window.innerWidth / 3);
    };

    // Attach the event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Add event listener to close the navbar when clicking outside of it
  useEffect(() => {
    const handleOutsideClick = (event) => {
      const navbar = document.getElementById("navbarSupportedContent");

      if (
        navbar &&
        !navbar.contains(event.target) &&
        !event.target.closest(".navbar-toggler")
      ) {
        // If the clicked element is not part of the navbar or its children, close the navbar
        navbar.classList.remove("show");
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    // <div className="galleryyyy gallery-page2">
    <div>
      <header className="sticky-top" style={{ background: "#1B1B19" }}>
        <nav class="navbar navbar-expand-lg navbar-light custom-navbar">
          <a class="navbar-brand mt-3" href="/">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="153"
              height="62"
              viewBox="0 0 153 62"
              fill="none"
              className="ml-sm-auto brand"
              style={{ left: "121px", top: "15px", position: "absolute" }}
            >
              <path
                d="M70.7885 42.1458C88.2584 28.8097 104.448 13.9911 121.748 0.532691C121.965 0.787726 122.189 1.04807 122.406 1.30311C117.89 5.00642 113.326 8.66723 108.863 12.4343C104.357 16.2386 99.8943 20.096 95.5003 24.0278C91.0531 28.0074 86.7122 32.1092 82.5998 36.5935C83.3011 36.2375 83.9706 35.7753 84.7145 35.5681C85.4052 35.3768 86.1756 35.4565 86.9141 35.414C86.8026 36.0675 86.7069 36.721 86.5741 37.3639C86.5263 37.6083 86.3934 37.8421 86.2181 38.2778C88.4497 38.6444 90.5962 39.1757 89.4698 42.4593C89.6717 42.4859 89.8683 42.5178 90.0702 42.5443C94.4058 39.4308 98.7626 36.3491 103.072 33.1984C111.812 26.8013 120.472 20.3032 129.271 13.9964C132.002 12.0358 135.084 10.5587 138.006 8.85851C138.139 9.04447 138.272 9.23575 138.405 9.42171C137.554 10.0699 136.72 10.7447 135.854 11.3663C125.547 18.7517 115.202 26.0893 104.953 33.549C102.546 35.3024 100.431 37.4489 98.2313 39.4733C97.9284 39.7496 97.9391 40.3606 97.8062 40.8122C98.226 40.86 98.6882 41.046 99.0602 40.9291C106.026 38.7826 113.268 39.9143 120.345 39.1226C125.074 38.5966 129.845 38.1875 134.595 38.2141C139.775 38.2459 144.956 38.8038 150.126 39.2289C151.103 39.3086 152.044 39.8346 153 40.1534C152.947 40.3447 152.894 40.5412 152.835 40.7325C152.118 40.6156 151.401 40.4456 150.678 40.3925C146.831 40.0843 142.969 39.4839 139.127 39.5796C128.288 39.8399 117.449 40.3393 106.621 40.8707C104.182 40.9929 101.775 41.6676 99.3418 42.0077C98.4173 42.1352 96.9508 42.4221 96.6108 41.9758C95.1018 39.9727 93.9913 41.301 92.7321 42.114C91.8448 42.6878 90.9681 43.3147 90.0011 43.7079C89.4326 43.9364 88.6941 43.7451 88.0352 43.7398C88.0352 43.166 87.9449 42.5656 88.0671 42.0183C88.5187 39.994 88.3168 39.7549 86.2394 39.8665C85.4796 39.909 84.7091 39.7815 83.944 39.7336C84.2363 39.0642 84.5338 38.3947 84.8207 37.7252C84.9217 37.4915 85.0014 37.2471 84.8101 36.5829C82.0047 38.3203 79.1993 40.0577 76.394 41.7952C76.2292 41.5986 76.0698 41.4073 75.9051 41.2107C76.6437 40.35 77.3769 39.4839 78.1154 38.6232C78.0623 38.5488 78.0039 38.4744 77.9507 38.4053C75.7723 40.0684 73.6523 41.8058 71.3995 43.3573C70.4697 43.9948 69.2583 44.2286 68.1744 44.6431C68.7057 43.6495 69.1627 42.5975 69.7949 41.6676C70.4644 40.6847 71.3092 39.8133 71.8883 38.7188C68.4773 41.131 65.0821 43.5645 61.6498 45.9501C60.348 46.8534 59.041 47.7938 57.6117 48.4473C56.8466 48.798 55.8159 48.5801 54.902 48.6173C55.1039 47.831 55.072 46.848 55.5449 46.2955C57.8242 43.6229 60.2205 41.046 62.6274 38.4903C63.2172 37.8634 64.0195 37.4436 64.8324 36.8432C61.9686 35.0793 61.6976 34.4789 63.6103 32.3217C68.727 26.525 73.7745 20.6326 79.3375 15.2769C83.8165 10.9679 88.9703 7.33893 93.9063 3.50809C95.5641 2.2223 97.4396 1.19153 99.2939 0.192645C99.8784 -0.120835 100.729 0.0545011 101.456 0.00668208C101.164 0.676148 101.021 1.49438 100.543 1.9832C98.7679 3.81095 96.9296 5.58556 95.0221 7.2858C90.4262 11.3876 85.793 15.4522 81.1333 19.4796C80.1451 20.3351 78.9815 20.9833 77.8976 21.7271L77.515 21.1533C84.8048 14.7031 92.0998 8.2528 99.3896 1.80255C99.2408 1.61127 99.092 1.42531 98.938 1.23404C94.9955 4.1138 90.915 6.82354 87.132 9.8999C79.2631 16.297 71.9202 23.2627 65.6453 31.2591C64.9015 32.2048 64.5933 33.4853 64.0832 34.6117C65.3743 34.2451 66.8461 34.1548 67.9247 33.4587C70.7301 31.6522 73.3442 29.5535 76.0805 27.6301C76.7287 27.1732 77.5522 26.9607 78.2961 26.6365C78.4555 26.881 78.6149 27.1307 78.7743 27.3751C77.4779 28.443 76.2983 29.7182 74.8584 30.5418C68.6526 34.0804 63.4616 38.7826 58.7594 44.0692C57.9518 44.9778 57.1973 45.9395 56.4216 46.8799C56.5172 47.0606 56.6128 47.2412 56.7032 47.4166C57.4895 47.0871 58.3609 46.8852 59.0463 46.407C63.0843 43.5857 67.0639 40.6741 71.102 37.8528C72.0956 37.1567 72.8394 35.6796 74.4759 36.4819C73.9286 37.5021 73.4451 38.5647 72.8182 39.537C72.2178 40.4615 71.4686 41.2851 70.7832 42.1565L70.7885 42.1458Z"
                fill="white"
              />
              <path
                d="M41.6668 6.63227C37.2249 11.2495 32.5971 15.7072 28.3837 20.5263C21.1418 28.7937 14.1655 37.2896 7.06707 45.6791C5.64844 47.3581 4.22981 49.0424 2.69961 50.6204C2.20016 51.1411 1.36599 51.3643 0.654016 51.6406C0.49462 51.7043 0.0376827 51.4599 0.0111166 51.3111C-0.0313892 51.0349 0.0483091 50.5939 0.244898 50.4451C8.18285 44.4837 12.6566 35.5203 19.415 28.544C26.3275 21.4083 33.2134 14.2514 40.11 7.10514C40.2322 6.97763 40.3703 6.86605 40.5085 6.75978C41.5286 5.97874 42.5753 4.74076 43.8611 5.77152C44.1374 5.99468 43.3723 7.98714 42.6816 8.84257C37.3259 15.4841 31.8692 22.0459 26.4497 28.6343C26.1309 29.0222 25.844 29.4419 25.8599 30.1539C27.5442 28.5759 29.1966 26.966 30.9128 25.4304C35.1103 21.6793 39.3024 17.9175 43.5955 14.2674C44.4456 13.5448 45.7367 13.3269 46.8206 12.8753C46.3158 13.9751 46.0342 15.2556 45.2798 16.1429C38.8933 23.6452 32.4218 31.0678 25.9821 38.5275C25.4455 39.1545 24.9833 39.8452 24.8398 40.8707C26.2212 39.8505 27.5708 38.7826 29.0001 37.8315C29.4357 37.5446 30.0893 37.5924 30.6418 37.4861C30.5728 37.9643 30.4346 38.4478 30.4452 38.926C30.4824 40.2543 30.3177 41.6623 30.7215 42.8844C31.1732 44.2446 32.1986 43.4104 32.7937 42.8366C35.0677 40.6369 37.3365 38.4266 39.499 36.1153C46.895 28.2039 54.3494 20.3616 62.8293 13.5713C64.2692 12.4184 65.7888 11.361 67.3349 10.3621C67.675 10.1443 68.2913 10.3409 68.7801 10.3515C68.7164 10.835 68.828 11.4567 68.5623 11.7755C67.3828 13.1941 66.1448 14.5702 64.8484 15.8879C58.5522 22.2903 52.1763 28.6131 45.9439 35.0739C42.4372 38.7135 39.1483 42.5603 35.9179 46.4283C38.5692 44.6006 41.1514 42.6718 43.8824 40.9769C45.8748 39.739 47.9789 38.8676 50.1095 41.0619C50.6514 41.6198 51.8628 41.5401 53.3612 41.8961C51.4431 42.8684 50.0404 43.1713 48.813 41.7367C47.7929 40.5412 46.6346 40.5572 45.5029 41.216C43.4573 42.4062 41.3002 43.5379 39.5574 45.1C34.5099 49.6162 29.643 54.3291 24.707 58.9675C23.9206 59.706 23.113 60.4339 22.316 61.1619L21.7794 60.6465C26.4231 55.2801 30.9819 49.8341 35.7319 44.5634C40.4979 39.2661 45.402 34.091 50.3379 28.9531C55.3271 23.7568 60.4384 18.672 65.4913 13.5341C65.369 13.396 65.2468 13.2525 65.1193 13.1144C62.468 15.3725 59.6626 17.4819 57.1973 19.9206C50.1307 26.9181 43.2182 34.0644 36.2154 41.1204C35.1049 42.2415 33.9042 43.2935 32.6343 44.2233C31.6514 44.9459 30.2221 45.286 29.6536 43.9789C28.9788 42.4328 28.1074 42.4965 26.5294 43.2829C26.9438 42.1405 27.1989 41.4498 27.4486 40.7538C27.3636 40.6369 27.2733 40.52 27.1882 40.3978C25.1745 41.9174 23.1661 43.4316 21.1524 44.9512C20.9346 44.7918 20.7221 44.6377 20.5042 44.4783C21.0887 43.4423 21.535 42.2999 22.2735 41.386C25.2595 37.6934 28.2828 34.0272 31.3857 30.4355C35.2962 25.9086 39.3024 21.4668 43.2607 16.9824C43.6592 16.5308 43.994 16.026 44.3553 15.5479C44.2118 15.3885 44.063 15.2344 43.9196 15.075C41.3852 17.3597 38.8242 19.6231 36.3164 21.9343C33.6597 24.3784 31.0084 26.8278 28.4369 29.3569C25.929 31.8223 23.5221 34.3939 21.078 36.9229C18.6658 39.4202 16.2643 41.928 13.8627 44.4305C13.6183 44.2446 13.3792 44.0639 13.1348 43.8779C13.8096 42.8791 14.4153 41.8217 15.1697 40.8919C24.0853 29.8882 33.0222 18.9111 41.9484 7.91806C42.1078 7.72148 42.214 7.47707 42.3469 7.25391L41.6349 6.63227H41.6668Z"
                fill="white"
              />
            </svg> */}
            <div className="brand">
              <h1>Marten Eckerstrom</h1>
              <span className="brand">Actor & Musician</span>
            </div>
          </a>
          <button
            style={{ color: "white", top: "20px", position: "relative" }}
            class="navbar-toggler text-white"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleShow}
          >
            {/* <span class="navbar-toggler-icon text-white"></span> */}
            {/* <i className="fa fa-bars" style={{ width: "26px" }}></i> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="18"
              viewBox="0 0 26 18"
              fill="none"
            >
              <line
                x1="1"
                y1="1"
                x2="25"
                y2="1"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="1"
                y1="9"
                x2="25"
                y2="9"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="1"
                y1="17"
                x2="25"
                y2="17"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>

          <div
            class="collapse navbar-collapse justify-content-center"
            id="navbarSupportedContent"
          >
            <button
              style={{
                color: "white",
                top: "20px",
                position: "relative",
                float: "right",
              }}
              class="navbar-toggler text-white"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleShow}
            >
              X
            </button>
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a
                  class="nav-link"
                  href="/"
                  style={{ color: openGalery ? "#BC9B5D" : "#ffff" }}
                >
                  Home <span class="sr-only">(current)</span>
                </a>
              </li>
              {isMobile ? (
                <li class="nav-item">
                  {/* <a
                  class="nav-link"
                  href={isMobile ? "/#acting3" : "/#acting2"}
                  style={{ color: "#ffff" }}
                >
                  Acting
                </a> */}
                  <a
                    class="nav-link navbar-toggler"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    href={isMobile ? "/#acting3" : "/#acting2"}
                    style={{
                      color: isMobile ? "white" : "#ffff",
                      top: isMobile && "3px",
                      position: "relative",
                      left: isMobile && "1px",
                    }}
                    // onClick={scrollToActing}
                    onClick={()=>{
                      window.location.href = '/#actings'
                    }}
                  >
                    Acting
                  </a>
                </li>
              ) : (
                <>
                  <li class="nav-item">
                    <a
                      class="nav-link "
                      href={isMobile ? "/#acting3" : "/#acting2"}
                      style={{
                        color: isMobile ? "white" : "#ffff",
                      }}
                    >
                      Acting
                    </a>
                  </li>
                </>
              )}

              <li class="nav-item">
                <a
                  href="/gallery"
                  class="nav-link "
                  onClick={clickGalery}
                  style={{ color: "#BC9B5D" }}
                >
                  Gallery
                </a>
              </li>
              {isMobile ? (
                <li class="nav-item">
                  {/* <a class="nav-link " href="#footer" style={{ color: "#ffff" }}>
                 Contact
               </a> */}
                  <a
                    class="nav-link navbar-toggler"
                    href="#footer"
                    // class="nav-link navbar-toggler"

                    style={{
                      color: isMobile ? "white" : "#ffff",
                      top: isMobile && "3px",
                      position: "relative",
                      left: isMobile && "1px",
                    }}
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    // onClick={toggleShow}
                    // style={{ color: isMobile ? "white" : "#ffff" }}
                    onClick={scrollToFooter}
                  >
                    Contact
                  </a>
                </li>
              ) : (
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#footer"
                    style={{
                      color: isMobile ? "white" : "#ffff",
                    }}
                  >
                    Contact
                  </a>
                </li>
              )}
            </ul>
          </div>
          <form class="form-inline2">
            <div>
              <a href="https://www.imdb.com/name/nm5103942/?ref_=nv_sr_srsg_0_tt_0_nm_2_q_m%25C3%25A5rten%2520eckestr%25C3%25B6m">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="56"
                  height="23"
                  viewBox="0 0 56 23"
                  fill="none"
                >
                  <path
                    d="M12.6966 21.5649H7.737V0.237823H15.2756L16.6643 9.18756H16.8627L17.8546 0.237823H25.3932V21.5649H20.4336V8.80672H20.2352L18.4498 21.5649H14.6805L12.6966 8.80672V21.5649Z"
                    fill="#BC9B5D"
                  />
                  <path
                    d="M27.377 0.0476055C28.1706 0.0476055 33.7253 -0.142815 36.7011 0.238024C39.0817 0.428444 40.272 2.33264 40.4704 4.61768C40.6688 8.80692 40.6688 12.9962 40.6688 17.1854C40.6688 17.5662 40.6688 18.1375 40.4704 18.7088C40.0736 20.4225 39.0817 21.3746 36.7011 21.565C33.7253 21.7555 30.7496 21.7555 27.9722 21.7555C27.9722 21.7555 27.7738 21.7555 27.5754 21.7555V0.0476055H27.377ZM33.3286 4.04642V17.7567C34.3205 17.7567 34.9156 17.3758 34.9156 16.4237C34.9156 12.8057 34.9156 8.99734 34.9156 5.18894C34.9156 4.23684 34.5189 3.856 33.3286 4.04642Z"
                    fill="#BC9B5D"
                  />
                  <path
                    d="M0 21.5649V0.237823H5.75315V21.5649H0Z"
                    fill="#BC9B5D"
                  />
                  <path
                    d="M55.3493 8.23546C55.1509 6.7121 54.159 5.95042 52.5719 5.56958C50.9848 5.37916 49.3977 5.56958 48.0091 6.90252V0.237823H42.4543V21.5649H47.6123C47.8107 21.184 47.8107 20.8032 48.0091 20.6128C48.0091 20.6128 48.0091 20.6128 48.2074 20.6128C48.4058 20.8032 48.6042 20.9936 48.8026 21.184C50.1913 22.1361 51.7784 22.3265 53.3654 21.7553C54.7541 21.184 55.3493 20.0415 55.3493 18.7086C55.3493 17.1852 55.5477 15.4714 55.5477 13.7576C55.5477 11.8534 55.5477 9.94924 55.3493 8.23546ZM49.7945 17.7565C49.7945 18.1373 49.3977 18.5181 49.001 18.5181C48.6042 18.5181 48.2074 18.1373 48.2074 17.7565V9.5684C48.2074 9.18756 48.6042 8.80672 49.001 8.80672C49.3977 8.80672 49.7945 9.18756 49.7945 9.5684V17.7565Z"
                    fill="#BC9B5D"
                  />
                </svg>
              </a>
            </div>
            <div>
              <a
                href="https://www.instagram.com/marteneckerstrom?igsh=MXJkem5obWFsdml4Mg=="
                // style={{ top: "-5px", position: "relative" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_836_31)">
                    <path
                      d="M12 2.163C15.204 2.163 15.584 2.175 16.85 2.233C20.102 2.381 21.621 3.924 21.769 7.152C21.827 8.417 21.838 8.797 21.838 12.001C21.838 15.206 21.826 15.585 21.769 16.85C21.62 20.075 20.105 21.621 16.85 21.769C15.584 21.827 15.206 21.839 12 21.839C8.796 21.839 8.416 21.827 7.151 21.769C3.891 21.62 2.38 20.07 2.232 16.849C2.174 15.584 2.162 15.205 2.162 12C2.162 8.796 2.175 8.417 2.232 7.151C2.381 3.924 3.896 2.38 7.151 2.232C8.417 2.175 8.796 2.163 12 2.163ZM12 0C8.741 0 8.333 0.014 7.053 0.072C2.695 0.272 0.273 2.69 0.073 7.052C0.014 8.333 0 8.741 0 12C0 15.259 0.014 15.668 0.072 16.948C0.272 21.306 2.69 23.728 7.052 23.928C8.333 23.986 8.741 24 12 24C15.259 24 15.668 23.986 16.948 23.928C21.302 23.728 23.73 21.31 23.927 16.948C23.986 15.668 24 15.259 24 12C24 8.741 23.986 8.333 23.928 7.053C23.732 2.699 21.311 0.273 16.949 0.073C15.668 0.014 15.259 0 12 0ZM12 5.838C8.597 5.838 5.838 8.597 5.838 12C5.838 15.403 8.597 18.163 12 18.163C15.403 18.163 18.162 15.404 18.162 12C18.162 8.597 15.403 5.838 12 5.838ZM12 16C9.791 16 8 14.21 8 12C8 9.791 9.791 8 12 8C14.209 8 16 9.791 16 12C16 14.21 14.209 16 12 16ZM18.406 4.155C17.61 4.155 16.965 4.8 16.965 5.595C16.965 6.39 17.61 7.035 18.406 7.035C19.201 7.035 19.845 6.39 19.845 5.595C19.845 4.8 19.201 4.155 18.406 4.155Z"
                      fill="#BC9B5D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_836_31">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            {/* <div>
              <a href="https://se.linkedin.com/in/marten-eckerstrom-311a101b2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_836_33)">
                    <path
                      d="M19 0H5C2.239 0 0 2.239 0 5V19C0 21.761 2.239 24 5 24H19C21.762 24 24 21.761 24 19V5C24 2.239 21.762 0 19 0ZM8 19H5V8H8V19ZM6.5 6.732C5.534 6.732 4.75 5.942 4.75 4.968C4.75 3.994 5.534 3.204 6.5 3.204C7.466 3.204 8.25 3.994 8.25 4.968C8.25 5.942 7.467 6.732 6.5 6.732ZM20 19H17V13.396C17 10.028 13 10.283 13 13.396V19H10V8H13V9.765C14.396 7.179 20 6.988 20 12.241V19Z"
                      fill="#BC9B5D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_836_33">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div> */}
          </form>
        </nav>
      </header>
      <div>
        {!isMobile && (
          <div className="main-box">
            <div className="row gallery-banner w-100">
              <div className="col-md-6">
                <h1>
                  <a
                    href="#video"
                    className="gallery-page-text"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    VIDEO
                  </a>
                </h1>
              </div>
              <div className="col-md-6">
                <h1>
                  <a
                    href="#image"
                    className="gallery-page-text"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    IMAGES
                  </a>
                </h1>
              </div>
            </div>
          </div>
        )}

        <div className="">
          <div className="gallery_bx2">
            <div className="container-fluid">
              {!isMobile && (
                <>
                  <h4
                    id="video"
                    className="text-center title"
                    style={{ top: "20px", position: "relative" }}
                  >
                    VIDEO GALLERY
                  </h4>
                  <div
                    className="row mt-4 test"
                    style={{
                      top: "50px",
                      position: "relative",
                      marginBottom: "100px",
                    }}
                  >
                    <div className="col-md-6 col-12 videos">
                      <div className="container-fluid">
                        <ReactPlayer
                          url={process.env.PUBLIC_URL + "/about.mp4"}
                          playing={isPlaying}
                          loop={true}
                          volume={1}
                          controls={true}
                          width="100%"
                          height="auto"
                          className="player"
                          light={
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/about_image_thumbnail.png"
                              }
                              alt="Thumbnail"
                              className="w-100"
                            />
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-12 videos">
                      <div className="container-fluid">
                        <ReactPlayer
                          url={process.env.PUBLIC_URL + "/port_vedio1.mp4"}
                          playing={isPlaying2}
                          loop={true}
                          volume={1}
                          controls={true}
                          width="100%"
                          height="auto"
                          className="player"
                          light={
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/driving_thumbnail.png"
                              }
                              alt="Thumbnail"
                              className="w-100"
                            />
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div>
              <NewGallery />
            </div>
          </div>
        </div>
      </div>
      {/* <div id="footer">
        <Footer />
      </div> */}
      <div id="footer" ref={footerRef}>
        {isMobile ? (
          <div
            className="text-white"
            style={{
              overflow: "visible",
              zIndex: "999",
              top: "100px",
              position: "relative",
            }}
          >
            <FooterMob />
          </div>
        ) : isTablet ? (
          <>
            <div
              className="text-white"
              style={{
                overflow: "visible",
                zIndex: "999",
                // top: "100px",
                // position: "relative",
              }}
            >
              <TabletFooter />
            </div>
          </>
        ) : (
          <>
            <Footer2 />
          </>
        )}
      </div>
    </div>
  );
}

export default GalleryScreen;
